import React from 'react';
import { SketchPicker } from 'react-color';

export const ColorPicker = ({ color, handleColorChange, width = 200 }) => (
  <SketchPicker width={width} color={color} onChange={handleColorChange} />
);
